import { Link } from 'react-router-dom';
import { getTopArticles } from '@/mocks/articles';

export default function HeroSection() {
  const topArticles = getTopArticles();

  if (topArticles.length === 0) return null;

  const mainArticle = topArticles[0];
  const sideArticles = topArticles.slice(1, 3);

  return (
    <section className="relative w-full">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20abstract%20composition%20with%20warm%20coral%20red%20and%20deep%20charcoal%20gradients%2C%20elegant%20flowing%20curves%2C%20luxurious%20texture%2C%20minimal%20modern%20design%2C%20soft%20glowing%20highlights%2C%20editorial%20background&width=1600&height=700&seq=hero-bg-main&orientation=landscape"
          alt="吃瓜爆料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>
      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <Link
            to={`/article/${mainArticle.id}`}
            className="lg:col-span-3 group cursor-pointer"
          >
            <div className="relative rounded-2xl overflow-hidden aspect-[16/9] lg:aspect-[16/8]">
              <img
                src={mainArticle.coverImage}
                alt={mainArticle.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-medium mb-3">
                  头条爆料
                </span>
                <h2 className="text-white text-xl md:text-3xl font-heading font-bold leading-tight mb-2 line-clamp-2">
                  {mainArticle.title}
                </h2>
                <p className="text-white/70 text-sm line-clamp-2 hidden md:block">
                  {mainArticle.excerpt}
                </p>
                <div className="flex items-center gap-3 mt-3 text-white/60 text-xs">
                  <span>{mainArticle.publishDate}</span>
                  <span>·</span>
                  <span>{(mainArticle.readCount / 10000).toFixed(1)}万阅读</span>
                </div>
              </div>
            </div>
          </Link>

          <div className="lg:col-span-2 flex flex-col gap-4">
            {sideArticles.map((article, index) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/10 hover:bg-white/15 transition-all duration-300 cursor-pointer"
              >
                <div className="w-24 h-24 md:w-28 md:h-28 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-accent-500 text-white text-xs font-medium mb-2">
                    {index === 0 ? '独家' : '热榜'}
                  </span>
                  <h3 className="text-white text-sm md:text-base font-heading font-semibold leading-snug line-clamp-2 group-hover:text-primary-300 transition-colors">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-2 text-white/50 text-xs">
                    <span>{article.publishDate}</span>
                    <span>·</span>
                    <span>{(article.readCount / 10000).toFixed(1)}万阅读</span>
                  </div>
                </div>
              </Link>
            ))}
            <Link
              to="/category/yule-bagua"
              className="flex items-center justify-center gap-1 text-white/60 hover:text-white text-sm py-2 transition-colors"
            >
              查看更多头条 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}